import { RichTextField } from '@prismicio/client';
import cx from 'classnames';
import Image from 'next/image';

import { PrismicImage } from '../../../../../core/Api/Prismic/Resources/image';
import { PrismicLinkWithLabel } from '../../../../../core/Api/Prismic/Resources/link';
import { useTrackEventAmplitude } from '../../../../../core/Tracking/Amplitude/Amplitude';
import { Button } from '../../../../../design-system/components/form/button/Button';
import { Typography } from '../../../../../design-system/components/typography/Typography';
import { EvaneosPrismicRichText } from '../../../../../domains/Prismic/EvaneosPrismicRichText';

import style from './PostBlock.module.css';

export type PostBlockProps = {
    title: string | null;
    text: RichTextField | null;
    picture: PrismicImage | null;
    ctaLabel: string | null;
    ctaLink: PrismicLinkWithLabel | null;
    target: string | null;
    gridSliceIndex?: number;
    sliceIndex?: number;
};

export function PostBlock({
    title,
    text,
    picture,
    ctaLabel,
    ctaLink,
    target,
    gridSliceIndex,
    sliceIndex,
}: PostBlockProps) {
    const { trackEvent } = useTrackEventAmplitude();

    return (
        <>
            {picture?.url ? (
                <Image
                    alt={picture.alt}
                    src={picture.url}
                    width={picture.width}
                    height={picture.height}
                    sizes="100vw"
                    className={style.image}
                />
            ) : null}
            <div className={cx(style.contentContainer)}>
                <Typography as="h2" scale="secondary-xl-bold">
                    {title}
                </Typography>
                <div className={style.textWrapper}>
                    {text ? <EvaneosPrismicRichText field={text} /> : null}
                    {ctaLabel && ctaLink?.url ? (
                        <div>
                            <Button
                                priority="text"
                                href={ctaLink?.url}
                                target={target || undefined}
                                onClick={() => {
                                    trackEvent((ampli, defaultProperties) => {
                                        ampli.postsListsArticleClicked({
                                            ...defaultProperties,
                                            card_number:
                                                gridSliceIndex !== undefined
                                                    ? gridSliceIndex + 1
                                                    : 0,
                                            post_title: title ?? '',
                                            block_index: sliceIndex ? sliceIndex + 1 : 0,
                                        });
                                    });
                                }}
                            >
                                {ctaLabel}
                            </Button>
                        </div>
                    ) : null}
                </div>
            </div>
        </>
    );
}
